import { applyMiddleware, compose, createStore } from 'redux';
// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'redux-logger'.
import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { Store } from '@mews-commander/types';
import { createErrorReporterMiddleware, createWebsocketMiddleware } from '@mews/framework';
import localStorageEnhancer from '../enhancers/localStorageEnhancer';
import {
    createAnalyticsMiddleware,
    createDocumentTitleMiddleware,
    createMessagesMiddleware,
    createTeardownMiddleware,
    errorHandler,
} from '../middleware';
import { combineRootAndAsyncReducers, reducers } from '../modules';
import websocketConfiguration from './websocketConfiguration';

export default ({ initialState = {}, thunkContent, sentryReporterService, middlewares }: $TSFixMe): Store => {
    const composeEnhancers = (window as $TSFixMe).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? (window as $TSFixMe).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              serialize: {
                  options: {
                      undefined: true,
                  },
              },
          })
        : compose;

    const finalMiddlewares = [
        createErrorReporterMiddleware({ loggerService: thunkContent.loggerService, sentryReporterService }),
        errorHandler,
        createTeardownMiddleware(),
        thunk.withExtraArgument(thunkContent),
        promiseMiddleware({ promiseTypeSuffixes: ['STARTED', 'SUCCEEDED', 'FAILED'] }),
        // @ts-expect-error $TSFixMeError: Argument of type '{ appClockService: any; onOpen: () => (dispatch: any, getState: any) => void; onMessage: (data: any) =...
        createWebsocketMiddleware({ ...websocketConfiguration, appClockService: thunkContent.appClockService }),
        createMessagesMiddleware(),
        createDocumentTitleMiddleware(document),
        createAnalyticsMiddleware({
            loggerService: thunkContent.loggerService,
            trackingConsentsService: thunkContent.trackingConsentsService,
            appClockService: thunkContent.appClockService,
        }),
        ...middlewares,
    ];

    if (process.env.NODE_ENV === 'development') {
        const logger = createLogger({ collapsed: true });
        finalMiddlewares.push(logger);
    }

    const store: Store = createStore(
        reducers,
        initialState,
        composeEnhancers(applyMiddleware(...finalMiddlewares), localStorageEnhancer)
    );

    (store as $TSFixMe).asyncReducers = {};

    (store as $TSFixMe).injectReducer = (key: $TSFixMe, asyncReducer: $TSFixMe) => {
        if (!(store as $TSFixMe).asyncReducers[key]) {
            (store as $TSFixMe).asyncReducers[key] = asyncReducer;
            // @ts-expect-error $TSFixMeError: Argument of type 'Reducer<CombinedState<{ [x: string]: unknown; }>, never>' is not assignable to parameter of type 'Redu...
            store.replaceReducer(combineRootAndAsyncReducers({ ...reducers, ...(store as $TSFixMe).asyncReducers }));
        }
    };

    return store;
};
